import React, {Component, Fragment} from "react";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import withFormGroup from "../../../../modules/commons/withFormGroup";
import * as R from "ramda";
import FlexView from "react-flexview";
import {defaultTableChange} from "../../../../modules/custom/customTable";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import {printPDF, tableColumns} from "./config";
import OnSubmissionHeaderInputModifying from "./onSubmissionHeaderInputModifying";
import OnSubmissionDetail from "./onSubmissionDetail";
import Api from "../../../../Services/Api";
import {contructQueryParam, fetchDataAsync, FormatCurrencyWithoutSymbol} from "../../../../Services/Utils";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import {mapToObjectDDL} from "../../../common/mapper";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";
import {ACTIVITY_TYPE, GenericSequenceType, HttpStatus, ReportType} from "../../../common/Constants";
import M from "moment/moment";
import SimplePrintButton from "../../../../modules/SimplePrintButton";
import moment from "moment/moment";
import PreviewPDF from "./previewPDF";

class OnSubmissionModifying extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            modifyingModalVisible: false,
            alertModalSaveVisible: false,
            previewCetakVisible: false,
            tableColumns: [...tableColumns.secondPage],
            dataSamsat: [],
            dataSupplier: [],
            rawDataSupplier: [],
            dataTable: [],
            dataBBN: [],
            dataExport: null,
            totalBBN: 0,
            alertNoDataPengajuanSamsat: false,
            pagination:{
                limit: 5,
                page: 1,
            }
        };
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        this.fetchDataSamsat();
        this.fetchDataSupplier();

        if (R.or(R.equals(this.props.action, "edit"), R.equals(this.props.action, "view"))) {
            await this.fetchData();
        }

        if (R.equals(this.props.action, "create")) {
            const kodeCabang = this.props.selectedCabang?.value;
            let nomorPengajuan = await this.fetchDataGenerateSeq(this.constructGenSeqPayload(kodeCabang));
            this.props.setValue("nomorPengajuan", nomorPengajuan);
            this.props.setValue("tanggalPengajuan", M(new Date()).format("DD-MM-YYYY"));
        }

        this.handleTriggerLoading();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!R.equals(prevState.dataTable, this.state.dataTable)) {
            this.calculateTotalBBN();
            this.props.setValue("dataDetail", this.state.dataTable);
        }

        if (!R.equals(prevProps.controls.kodeSamsat, this.props.controls.kodeSamsat)) {
            if (!R.isNil(this.props.controls.kodeSamsat?.value)) {
                this.fetchDataBBN();
            } else {
                this.setState((prevValue) => ({...prevValue, dataBBN: []}));
                this.props.setValue("bbnId", null);
            }
        }

        if (!R.equals(prevProps.controls.bbnId, this.props.controls.bbnId)) {
            if (R.isNil(this.props.controls.bbnId?.value)) {
                this.setState((prevValue) => ({...prevValue, dataTable: []}));
            }
        }
    }

    constructGenSeqPayload = (kodeCabang) => {
        return {
            seqType: GenericSequenceType.TRANSACTION_SAMSAT,
            nosDealerCode: kodeCabang,
            transactionType: GenericSequenceType.TRANSACTION_SAMSAT,
        }
    }

    calculateTotalBBN = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            totalBBN: R.sum(R.map((item) => item.nominalBBN, this.state.dataTable)),
        }))
    }

    handleModifyingModalVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            modifyingModalVisible: !prevValue.modifyingModalVisible,
        }));
    };

    handleAlertModalSaveVisibility = () => {
        this.setState((prevState) => ({
            ...prevState,
            alertModalSaveVisible: !prevState.alertModalSaveVisible,
        }));
    }

    handleSubmitForDaftSubmission = (draft) => {
        this.setState((prevState) => ({
            ...prevState,
            dataTable: draft,
        }))
        this.handleModifyingModalVisibility();
    }

    handleSubmit = () => {
        if (this.props.validate()) {
            this.handleAlertModalSaveVisibility();
            this.props.onSubmit(this.props.controls, this.props.action === "edit" ? ACTIVITY_TYPE.UPDATE : ACTIVITY_TYPE.CREATE);
        }
    };

    handleAlertNoDataPengajuanVisibility = () => {
        this.setState((prev) => ({
            ...prev,
            alertNoDataPengajuanSamsat: !prev.alertNoDataPengajuanSamsat,
        }));
    };

    validateDataPengajuan = () => {
        if (this.state.dataTable.length === 0) {
            this.handleAlertNoDataPengajuanVisibility();
            return false;
        }
        return true;
    };

    getAdditionalDataCabang = async (kodeCabang) => {
        const selected = this.props.rawDataCabang?.find(
            (item) => item.kodeCabang === kodeCabang
        );
        console.log(kodeCabang, 'selected', this.props.rawDataCabang, 'selected', this.props)

        if (!selected) {
            return {
                alamat: "",
                phone: "",
                provinceName: "",
                kabupatenName: "",
            };
        }

        const api = Api.create("NAGAMAS_MASTER_DATA");
        const [provinceRes, cityRes] = await Promise.all([
            api.getAllProvince(),
            api.getCityById(selected.idKota),
        ]);

        const province = provinceRes.ok
            ? provinceRes.data.data?.find((p) => p.id === selected.idProvince)
            : null;

        const kabupaten = cityRes.ok
            ? cityRes.data.data?.kabKotName
            : null;
        console.log(selected, province, kabupaten)

        return {
            alamat: selected.alamat,
            phone: selected.phoneCRM,
            provinceName: province?.provinceName || "",
            kabupatenName: kabupaten || "",
        };
    };

    constructDataDetailCetakan = () => {
        const countByType = {};

        const transformed = this.state.dataTable.map((item, index) => {
            const idType = item.dataVariant.idType;
            countByType[idType] = (countByType[idType] || 0) + 1;

            return {
                no: index + 1,
                namaSTNK: item.namaSTNK,
                nomorFakturJual: item.nomorFakturJual,
                tipeUnitBerkas: item.dataVariant.namaVariant,
                biayaBerkas: item.nominalBBN,
                idType,
            };
        });

        return transformed.map(item => ({
            no: item.no,
            namaSTNK: item.namaSTNK,
            nomorFakturJual: item.nomorFakturJual,
            tipeUnitBerkas: item.tipeUnitBerkas,
            biayaBerkas: item.biayaBerkas || 0,
            totalNilaiBBN: item.biayaBerkas * countByType[item.idType],
            totalItem: countByType[item.idType],
        }));
    };

    handlePrintPdf = async () => {
        if (this.validateDataPengajuan()) {
            const {controls, selectedCabang} = this.props;

            let payload = {
                nomorPengajuan: controls.nomorPengajuan?.value,
            };

            if (this.props.action === 'create') {
                const additionalDataCabang = await this.getAdditionalDataCabang(
                    selectedCabang?.value
                );

                const selectedSupplier = this.state.rawDataSupplier.find(
                    (item) => item.supplierCode === controls.noSupplier.value?.value
                );
                const detail = this.constructDataDetailCetakan();
                const totalBerkas = detail.reduce(
                    (total, item) => total + (item.nominalBBN || 0),
                    0
                );

                payload = {
                    ...payload,
                    dataHeader: {
                        namaCabang: selectedCabang?.value,
                        alamatCabang: additionalDataCabang?.alamat,
                        teleponCabang: additionalDataCabang?.phone,
                        faxCabang: "",
                        kabkotName: additionalDataCabang?.kabupatenName,
                        provinceName: additionalDataCabang?.provinceName,
                        nomorPengajuan: controls.nomorPengajuan?.value,
                        namaBirojasa: controls.noSupplier.value?.label,
                        namaPembuatPengajuan: this.props.auth?.user?.username,
                        pembuatPengajuanUserId: this.props.auth?.user?.idUser,
                        tanggalPengajuan: moment().format("DD-MM-YYYY"),
                        namaPenerima: selectedSupplier?.namaPic,
                        supplierCode: selectedSupplier?.supplierCode,
                        biayaTotalBerkas: totalBerkas,
                    },
                    dataDetail: detail,
                };
            }
            let res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_REPORT").generateCetakanPengajuanSamsat,
                menuName: "Pengajuan Samsat",
                setError: this.props.setError,
                args: payload,
            });
            if (res?.ok) {
                printPDF(res.data)
                await fetchDataAsync({
                    asyncFn: Api.create("NAGAMAS_REPORT_DTO").updatePrintCount,
                    menuName: "Pengajuan Samsat",
                    setError: this.props.setError,
                    args: {
                        refNumber: controls.nomorPengajuan?.value,
                        type: ReportType.SAMSAT,
                    }
                });
            }
        }
    };

    previewCetakanVisibility = () => {
       this.setState((prevState) => ({
         ...prevState,
         previewCetakVisible: !prevState.previewCetakVisible,
       }));
     };

   handlePreview = async () => {
      if (this.validateDataPengajuan()) {
        const { controls, selectedCabang } = this.props;

        let payload = {
          nomorPengajuan: controls.nomorPengajuan?.value,
        };

        if (this.props.action === "create") {
          const additionalDataCabang = await this.getAdditionalDataCabang(
            selectedCabang?.value
          );

          const selectedSupplier = this.state.rawDataSupplier.find(
            (item) => item.supplierCode === controls.noSupplier.value?.value
          );
          const detail = this.constructDataDetailCetakan();
          const totalBerkas = detail.reduce(
            (total, item) => total + (item.nominalBBN || 0),
            0
          );

          payload = {
            ...payload,
            dataHeader: {
              namaCabang: selectedCabang?.value,
              alamatCabang: additionalDataCabang?.alamat,
              teleponCabang: additionalDataCabang?.phone,
              faxCabang: "",
              kabkotName: additionalDataCabang?.kabupatenName,
              provinceName: additionalDataCabang?.provinceName,
              nomorPengajuan: controls.nomorPengajuan?.value,
              namaBirojasa: controls.noSupplier.value?.label,
              namaPembuatPengajuan: this.props.auth?.user?.username,
              pembuatPengajuanUserId: this.props.auth?.user?.idUser,
              tanggalPengajuan: moment().format("DD-MM-YYYY"),
              namaPenerima: selectedSupplier?.namaPic,
              supplierCode: selectedSupplier?.supplierCode,
              biayaTotalBerkas: totalBerkas,
            },
            dataDetail: detail,
          };
        }

        let res = await fetchDataAsync({
          asyncFn: Api.create("NAGAMAS_REPORT").generateCetakanPengajuanSamsat,
          menuName: "Pengajuan Samsat",
          setError: this.props.setError,
          args: payload,
        });

        if (res?.ok) {
          const pdfBlob = new Blob([res.data], { type: "application/pdf" });
          const pdfUrl = URL.createObjectURL(pdfBlob);

          this.setState({
            PDF: pdfUrl,
            previewVisible: true,
          });
        }
      }
    };


    handlePrint = async (value) => {
        this.props.triggerLoading();
        if (value !== null && R.equals(value, "excel")) {
            let reqBody;
            const {action} = this.props;
            const {dataExport} = this.state;
            if (R.equals(action, "view")) {
                reqBody = dataExport;
            }

            if (reqBody) {
                let res = await fetchDataAsync({
                    asyncFn: Api.create("NAGAMAS_TRANSACTION_FILE").exportToExcelSubmission,
                    menuName: "Pengajuan Samsat",
                    setError: this.props.setError,
                    args: reqBody,
                });
                if (res.ok) {
                    const blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = "Pengajuan_Samsat.xlsx";
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    window.URL.revokeObjectURL(url);
                }
            }
        } else {
            await this.handlePrintPdf();
        }
        this.props.triggerLoading();
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    fetchData = async () => {
        let response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").findDetailOnSubmissionSamsat,
            menuName: "Process Samsat",
            setError: this.props.setError,
            args: contructQueryParam({nomorPengajuan: this.props.controls.nomorPengajuan?.value}),
        });
        if (response.ok && response.data.data !== null && response.data.status === HttpStatus.SUCCESS) {
            this.props.setValue("nomorPengajuan", response.data.data?.nomorPengajuan);
            this.props.setValue("tanggalPengajuan", response.data.data?.tanggalPengajuan);
            this.props.setValue("kodeSamsat", mapToObjectDDL(
                response.data.data?.dataSamsat?.samsatName,
                response.data.data?.dataSamsat?.samsatId,
            ));
            this.props.setValue("noSupplier", mapToObjectDDL(
                response.data.data?.dataBirojasa?.supplierName,
                response.data.data?.dataBirojasa?.supplierCode,
            ));
            this.props.setValue("noBKK", response.data.data?.noBKK);
            this.props.setValue("dataDetail", response.data.data?.dataDetailSubmission);
            this.props.setValue("bbnId", mapToObjectDDL(
                response.data.data?.dataBbn?.bbnName,
                response.data.data?.dataBbn?.id,
            ));

            this.setState((prevValue) => ({
                ...prevValue,
                dataExport: response.data.data,
                dataTable: !R.isNil(response.data.data?.dataDetailSubmission)
                    ? response.data.data?.dataDetailSubmission : [],
            }));
        }else{
            this.props.onClickClose();
        }
    }

    fetchDataSamsat = async () => {
        try {
            const response = await Api.create("NAGAMAS_MASTER_DATA").getAllMasterSamsat({
                listCabang: [this.props.selectedCabang?.value],
            });
            if (response.ok && response.data.data !== null) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    dataSamsat: !R.isNil(response.data.data)
                        ? response.data.data.map(item => mapToObjectDDL(item.samsatName, item.samsatId))
                        : [],
                }));
            }
        } catch (error) {
            console.log("error: ", error);
        }
    }

    fetchDataSupplier = async () => {
        try {
            const response = await Api.create("NAGAMAS_MASTER_DATA").getAllMasterSupplier({
                jenisSupplier: "SPL04",
                cabang: [this.props.selectedCabang?.value],
            });
            if (response.ok && response.data.data !== null) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    dataSupplier: !R.isNil(response.data.data)
                        ? response.data.data.map(item => mapToObjectDDL(item.supplierName, item.supplierCode))
                        : [],
                    rawDataSupplier: response.data.data
                }));
            }
        } catch (error) {
            console.log("error: ", error);
        }
    }

    fetchDataBBN = async () => {
        try {
            const response = await Api.create("NAGAMAS_MASTER_DATA").getAllMasterBBN({
                kodeSamsat: [this.props.controls.kodeSamsat?.value?.value],
            });
            if (response.ok && response.data.data !== null) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    dataBBN: !R.isNil(response.data.data)
                        ? response.data.data.map(item => mapToObjectDDL(item.bbnName, item.id))
                        : [],
                }));
            }
        } catch (error) {
            console.log("error: ", error);
        }
    }

    fetchDataGenerateSeq = async (body) => {
        try {
            let res = await Api.create("NAGAMAS_MASTER_DATA").generateSeqWithoutSave(body);
            if (res.ok) {
                return res.data;
            }
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: tableState.page + 1,
            }
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: 1,
                limit: tableState.rowsPerPage,
            }
        }));
    };

    render() {
        const {pagination} = this.state;
        return (
            <Fragment>
                <SimpleModal
                    title="Form Data Proses Pengajuan SAMSAT"
                    visible={this.props.visible}
                    onClickClose={() => this.props.onClickClose()}
                    content={
                        <ModalContainer>
                            <OnSubmissionHeaderInputModifying
                                {...this.props}
                                dataSamsat={this.state.dataSamsat}
                                dataSupplier={this.state.dataSupplier}
                                dataBBN={this.state.dataBBN}
                            />
                            <SimpleDataTable
                                key={`${this.state.dataTable?.length}-${pagination.page}`}
                                data={this.state.dataTable}
                                columns={this.state.tableColumns}
                                toCount={this.state.dataTable.length}
                                rowsPerPage={pagination.limit}
                                page={pagination.page - 1}
                                options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
                            />

                            <div className="grid grid-3x gap-20px grid-mobile-none margin-top-20px">
                                <div id="grid-1"></div>
                                <div id="grid-2"></div>
                                <div id="grid-3">
                                    <FlexView column style={{gap: "20px"}}>
                                        <FlexView style={{justifyContent: "space-between", gap: "20px"}}>
                                            <div className="txt-site txt-11 txt-main txt-bold">
                                                <h4>Total Item</h4>
                                            </div>
                                            <input
                                                disabled
                                                type="text"
                                                className="txt txt-sekunder-color"
                                                name="totalItem"
                                                style={{width: "50%", textAlign: "right", backgroundColor: "#E6E6E6"}}
                                                value={this.state.dataTable?.length}
                                            />
                                        </FlexView>
                                        <FlexView style={{justifyContent: "space-between", gap: "20px"}}>
                                            <div className="txt-site txt-11 txt-main txt-bold">
                                                <h4>Total Nilai BBN (Rp)</h4>
                                            </div>
                                            <input
                                                disabled
                                                type="text"
                                                className="txt txt-sekunder-color"
                                                name="totalBBN"
                                                style={{width: "50%", textAlign: "right", backgroundColor: "#E6E6E6"}}
                                                value={FormatCurrencyWithoutSymbol({number:this.state.totalBBN})}
                                            />
                                        </FlexView>
                                    </FlexView>
                                </div>
                            </div>

                            <div style={{textAlign: "right", marginTop: "20px"}}>
                                <FlexView hAlignContent={"right"}>
                                    <SimpleButton
                                      text="Preview"
                                      onClick={() => this.handlePreview()}
                                    />
                                    <SimplePrintButton
                                        text="Cetak"
                                        toPdf
                                        toExcel
                                        onPrint={(value) => this.handlePrint(value)}
                                    />
                                    {R.or(R.equals(this.props.action, "edit"), R.equals(this.props.action, "create")) && (
                                        <>
                                            <SimpleButton
                                                type="button"
                                                icon={<i className="fa fa-plus margin-right-10px"></i>}
                                                text={"Tambah"}
                                                onClick={this.handleModifyingModalVisibility}
                                            />
                                            <SimpleButton
                                                type="button"
                                                text="Simpan"
                                                onClick={this.handleAlertModalSaveVisibility}
                                            />
                                        </>
                                    )}
                                </FlexView>
                            </div>
                        </ModalContainer>
                    }
                />

                {this.state.modifyingModalVisible && (
                    <OnSubmissionDetail
                        {...this.props}
                        dataDetail={this.state.dataTable}
                        selectedCabang={this.props.selectedCabang}
                        visible={this.state.modifyingModalVisible}
                        onClickClose={this.handleModifyingModalVisibility}
                        onSubmitDetail={this.handleSubmitForDaftSubmission}
                    />
                )}

                {this.state.alertNoDataPengajuanSamsat && (
                    <SimpleAlert
                        title="Information"
                        visible={this.state.alertNoDataPengajuanSamsat}
                        onClickClose={() => this.handleAlertNoDataPengajuanVisibility()}
                        content={"Harap pilih data pengajuan samsat!"}
                    />
                )}

                {this.state.previewVisible && (
                  <PreviewPDF
                    title="Preview PDF"
                    PDF={this.state.PDF}
                    visible={this.state.previewVisible}
                    onPreviewQr={() => this.setState({ previewVisible: false })}
                    onStateChange={(newState) => this.setState(newState)}
                  />
                )}

                {this.state.alertModalSaveVisible && (
                    <SimpleAlert
                        title={"Information"}
                        content={
                            <span>
                                Pengajuan dokumen ke {this.props.controls.kodeSamsat.value?.label} sejumlah {this.state.dataTable?.length} dengan faktur senilai {this.state.totalBBN} akan dilakukan.
                                <br/>
                Apakah anda yakin?
              </span>
                        }
                        visible={this.state.alertModalSaveVisible}
                        onClickClose={this.handleAlertModalSaveVisibility}
                        additionalButtons={
                            <FlexView>
                                <SimpleButton
                                    secondary
                                    type="button"
                                    text="Batal"
                                    onClick={() => this.handleAlertModalSaveVisibility()}
                                />
                                <SimpleButton
                                    type="button"
                                    text="Iya"
                                    onClick={() => this.handleSubmit()}
                                />
                            </FlexView>
                        }
                    />
                )}

                <SimpleLoadingOverlay active={this.state.loading}/>
            </Fragment>
        );
    }
}

export default withFormGroup(OnSubmissionModifying);
